// $(document).ready(function () {
//     var mySwiper = new Swiper(".logo_main_section_wrap .swiper-container", {
//         spaceBetween: 0,
//         centeredSlides: !0,
//         speed: 6000,
//         autoplay: { delay: 1 },
//         loop: !0,
//         slidesPerView: "auto",
//         allowTouchMove: !1,
//         disableOnInteraction: !0,
//     });
//     var mySwiper = new Swiper(".custom-new-grid.custom_slider-collection .swiper-container", {
//         freeMode: !0,
//         slidesPerView: 4,
//         spaceBetween: 12,
//         pagination: { el: ".slider__pagination", clickable: !0 },
//         navigation: { nextEl: ".slider__button-next", prevEl: ".slider__button-prev" },
//         breakpoints: {
//             768: { slidesPerView: 4, spaceBetween: 12 },
//             481: { slidesPerView: 2, freeMode: !1, spaceBetween: 12 },
//             320: { slidesPerView: 1, freeMode: !1, loop: !0, spaceBetween: 12 },
//         },
//     });
//     $(document).on("click", ".custom_contact_form .custom_contact_tab p.custom_contact_tabIn", function () {
//         $(".custom_contact_form .custom_contact_tab p.custom_contact_tabIn").removeClass("active");
//         $(this).addClass("active");
//         var data_handle = $(this).attr("data-handle");
//         $(".custom_contact_form .tab_data_main").hide();
//         $(".custom_contact_form .tab_data_main[data-handle='" + data_handle + "']").show();
//     });
//     var mySwiper = new Swiper(".custom_slideshow-wrapper .swiper-container", {
//         freeMode: !0,
//         slidesPerView: 4.5,
//         spaceBetween: 32,
//         scrollbar: { el: ".swiper-scrollbar", draggable: !0, snapOnRelease: !1 },
//         breakpoints: {
//             1025: { slidesPerView: 4.5, spaceBetween: 32 },
//             768: { slidesPerView: 3.5, spaceBetween: 20 },
//             320: { slidesPerView: 1.2, spaceBetween: 12 },
//         },
//     });

// $(document).ready(function () {
//   if ($("#priceidd").val().trim() === "") {
//     $("#priceidd").val("10000");
//   }

//   $(".custom_calculator_wrapp .product_btn_bottom a.btn.js-no-transition").on("click", function (e) {
//     e.preventDefault();

//     var selected_url1 = $(".all_collection_data select option:selected").data("url");
//     var selected_url2 = $(".product_types_wrapp select option:selected").data("url");
//     var selected_val3 = $("#priceidd").val().trim();

//     $(".price_error_msg").remove();

//     if (selected_val3 === "" || isNaN(selected_val3) || Number(selected_val3) <= 0) {
//       $("#priceidd").css({ "border": "2px solid #234381", "outline": "none" });
//       $("#priceidd").focus();
//       return false;
//     }

//     $("#priceidd").css({ "border": "", "outline": "" });

//     var base_url = selected_url1; 

//     window.location.href =
//       base_url +
//       "?filter.v.price.gte=0.00&filter.v.price.lte=" +
//       selected_val3 +
//       ".00";
//   });

//   $("#priceidd").on("input", function () {
//     if ($(this).val().trim() !== "") {
//       $(this).css({ "border": "", "outline": "" });
//     }
//   });
// });



//     $(".label-input-cross-wrapp input.input-full").each(function () {
//         if ($(this).val().length == 0) {
//             $(this).parents(".label-input-cross-wrapp").removeClass("input_focused");
//         } else {
//             $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
//         }
//     });
//     $(".label-input-cross-wrapp input.input-full").focus(function () {
//         $(".label-input-cross-wrapp input.input-full").each(function () {
//             if ($(this).val().length == 0) {
//                 $(this).parents(".label-input-cross-wrapp").removeClass("input_focused");
//             }
//         });
//         $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
//     });
//     $(".label-input-cross-wrapp label.form-label").click(function () {
//         $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
//         $(this).parents(".label-input-cross-wrapp").find("input").focus();
//     });
//     $(".label-input-cross-wrapp .cross_input").click(function () {
//         $(this).parents(".label-input-cross-wrapp").find("input").val("");
//         $(this).parents(".label-input-cross-wrapp").find("input").blur();
//     });
//     $(".label-input-cross-wrapp input.input-full").blur(function () {
//         $(".label-input-cross-wrapp input.input-full").each(function () {
//             if ($(this).val().length == 0) {
//                 $(this).parents(".label-input-cross-wrapp").removeClass("input_focused");
//             } else {
//                 $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
//             }
//         });
//     });

    
//     function getCookie(cname) {
//         var name = cname + "=";
//         var ca = document.cookie.split(";");
//         for (var i = 0; i < ca.length; i++) {
//             var c = ca[i];
//             while (c.charAt(0) == " ") {
//                 c = c.substring(1);
//             }
//             if (c.indexOf(name) == 0) {
//                 return c.substring(name.length, c.length);
//             }
//         }
//         return "";
//     }
//     function delete_cookie(name) {
//         document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
//     }
//     var appointmentform = getCookie("appointmentform");
//     if (appointmentform.indexOf("appointmentform") > -1) {
//         var header_height = $("div#HeaderWrapper").height();
//         $("html, body").animate({ scrollTop: $(".custom-map-form-sec").offset().top - header_height }, 2000);
//         delete_cookie("appointmentform");
//     }
//     $(".homepage_header").click(function (e) {
//         e.preventDefault();
//         var header_height = $("div#HeaderWrapper").height();
//         $("html, body").animate({ scrollTop: $(".custom-map-form-sec").offset().top - header_height }, 2000);
//     });
// });


$(document).ready(function () {

    /* =========================================================
       LOGO SWIPER
    ========================================================= */
    if ($(".logo_main_section_wrap .swiper-container").length) {
        new Swiper(".logo_main_section_wrap .swiper-container", {
            spaceBetween: 0,
            centeredSlides: true,
            speed: 6000,
            autoplay: {
                delay: 1
            },
            loop: true,
            slidesPerView: "auto",
            allowTouchMove: false,
            disableOnInteraction: true
        });
    }


    /* =========================================================
       COLLECTION SWIPER
    ========================================================= */
    if ($(".custom-new-grid.custom_slider-collection .swiper-container").length) {
        new Swiper(".custom-new-grid.custom_slider-collection .swiper-container", {
            freeMode: true,
            slidesPerView: 4,
            spaceBetween: 12,

            pagination: {
                el: ".slider__pagination",
                clickable: true
            },

            navigation: {
                nextEl: ".slider__button-next",
                prevEl: ".slider__button-prev"
            },

            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 12
                },

                481: {
                    slidesPerView: 2,
                    freeMode: false,
                    spaceBetween: 12
                },

                320: {
                    slidesPerView: 1,
                    freeMode: false,
                    loop: true,
                    spaceBetween: 12
                }
            }
        });
    }


    /* =========================================================
       CONTACT FORM TABS
    ========================================================= */
    $(document).on(
        "click",
        ".custom_contact_form .custom_contact_tab p.custom_contact_tabIn",
        function () {

            $(".custom_contact_form .custom_contact_tab p.custom_contact_tabIn")
                .removeClass("active");

            $(this).addClass("active");

            var data_handle = $(this).attr("data-handle");

            $(".custom_contact_form .tab_data_main").hide();

            $(".custom_contact_form .tab_data_main[data-handle='" + data_handle + "']")
                .show();
        }
    );


    /* =========================================================
       CUSTOM SLIDESHOW
    ========================================================= */
    if ($(".custom_slideshow-wrapper .swiper-container").length) {
        new Swiper(".custom_slideshow-wrapper .swiper-container", {
            freeMode: true,
            slidesPerView: 4.5,
            spaceBetween: 32,

            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                snapOnRelease: false
            },

            breakpoints: {
                1025: {
                    slidesPerView: 4.5,
                    spaceBetween: 32
                },

                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 20
                },

                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 12
                }
            }
        });
    }


    /* =========================================================
       PRICE CALCULATOR
       
       IMPORTANT:
       This section only runs if #priceidd exists.
       This prevents:
       
       Cannot read properties of undefined (reading 'trim')
       
       on pages such as fiche-agence.
    ========================================================= */
    if ($("#priceidd").length) {

        var $priceInput = $("#priceidd");

        var initialPrice = $priceInput.val() || "";

        if ($.trim(initialPrice) === "") {
            $priceInput.val("10000");
        }


        $(".custom_calculator_wrapp .product_btn_bottom a.btn.js-no-transition")
            .on("click", function (e) {

                e.preventDefault();

                var selected_url1 =
                    $(".all_collection_data select option:selected")
                        .data("url") || "";

                var selected_url2 =
                    $(".product_types_wrapp select option:selected")
                        .data("url") || "";

                var selected_val3 =
                    $priceInput.val() || "";

                selected_val3 = $.trim(selected_val3);


                $(".price_error_msg").remove();


                if (
                    selected_val3 === "" ||
                    isNaN(selected_val3) ||
                    Number(selected_val3) <= 0
                ) {

                    $priceInput.css({
                        "border": "2px solid #234381",
                        "outline": "none"
                    });

                    $priceInput.focus();

                    return false;
                }


                $priceInput.css({
                    "border": "",
                    "outline": ""
                });


                var base_url = selected_url1;


                window.location.href =
                    base_url +
                    "?filter.v.price.gte=0.00&filter.v.price.lte=" +
                    selected_val3 +
                    ".00";
            });


        $priceInput.on("input", function () {

            var value = $(this).val() || "";

            if ($.trim(value) !== "") {

                $(this).css({
                    "border": "",
                    "outline": ""
                });
            }
        });
    }


    /* =========================================================
       FORM INPUT FOCUS STATE
    ========================================================= */
    $(".label-input-cross-wrapp input.input-full").each(function () {

        var value = $(this).val() || "";

        if ($.trim(value).length === 0) {

            $(this)
                .parents(".label-input-cross-wrapp")
                .removeClass("input_focused");

        } else {

            $(this)
                .parents(".label-input-cross-wrapp")
                .addClass("input_focused");
        }
    });


    $(".label-input-cross-wrapp input.input-full").on(
        "focus",
        function () {

            $(".label-input-cross-wrapp input.input-full").each(
                function () {

                    var value = $(this).val() || "";

                    if ($.trim(value).length === 0) {

                        $(this)
                            .parents(".label-input-cross-wrapp")
                            .removeClass("input_focused");
                    }
                }
            );


            $(this)
                .parents(".label-input-cross-wrapp")
                .addClass("input_focused");
        }
    );


    $(".label-input-cross-wrapp label.form-label").on(
        "click",
        function () {

            $(this)
                .parents(".label-input-cross-wrapp")
                .addClass("input_focused");

            $(this)
                .parents(".label-input-cross-wrapp")
                .find("input")
                .focus();
        }
    );


    $(".label-input-cross-wrapp .cross_input").on(
        "click",
        function () {

            $(this)
                .parents(".label-input-cross-wrapp")
                .find("input")
                .val("")
                .blur();
        }
    );


    $(".label-input-cross-wrapp input.input-full").on(
        "blur",
        function () {

            $(".label-input-cross-wrapp input.input-full").each(
                function () {

                    var value = $(this).val() || "";

                    if ($.trim(value).length === 0) {

                        $(this)
                            .parents(".label-input-cross-wrapp")
                            .removeClass("input_focused");

                    } else {

                        $(this)
                            .parents(".label-input-cross-wrapp")
                            .addClass("input_focused");
                    }
                }
            );
        }
    );


    /* =========================================================
       COOKIE FUNCTIONS
    ========================================================= */
    function getCookie(cname) {

        var name = cname + "=";
        var ca = document.cookie.split(";");

        for (var i = 0; i < ca.length; i++) {

            var c = ca[i];

            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }

            if (c.indexOf(name) === 0) {
                return c.substring(
                    name.length,
                    c.length
                );
            }
        }

        return "";
    }


    function delete_cookie(name) {

        document.cookie =
            name +
            "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }


    /* =========================================================
       APPOINTMENT COOKIE
    ========================================================= */
    var appointmentform = getCookie("appointmentform");

    if (
        appointmentform &&
        appointmentform.indexOf("appointmentform") > -1 &&
        $(".custom-map-form-sec").length
    ) {

        var header_height =
            $("div#HeaderWrapper").height() || 0;

        var sectionOffset =
            $(".custom-map-form-sec").offset();

        if (sectionOffset) {

            $("html, body").animate(
                {
                    scrollTop:
                        sectionOffset.top - header_height
                },
                2000
            );
        }

        delete_cookie("appointmentform");
    }


    /* =========================================================
       HOMEPAGE HEADER SCROLL
    ========================================================= */
    $(".homepage_header").on("click", function (e) {

        e.preventDefault();

        if (!$(".custom-map-form-sec").length) {
            return;
        }

        var header_height =
            $("div#HeaderWrapper").height() || 0;

        var sectionOffset =
            $(".custom-map-form-sec").offset();

        if (!sectionOffset) {
            return;
        }

        $("html, body").animate(
            {
                scrollTop:
                    sectionOffset.top - header_height
            },
            2000
        );
    });

});